// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * CSS pour le composant AlertMessage
 */

.alert-message {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.alert-success {
  background-color: #dcfce7;
  border: 1px solid #86efac;
  color: #166534;
}

.alert-error {
  background-color: #fee2e2;
  border: 1px solid #fca5a5;
  color: #991b1b;
}

.alert-warning {
  background-color: #fef3c7;
  border: 1px solid #fcd34d;
  color: #92400e;
}

.alert-info {
  background-color: #dbeafe;
  border: 1px solid #93c5fd;
  color: #1e40af;
}

.alert-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-weight: bold;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.alert-success .alert-icon {
  background-color: #22c55e;
  color: white;
}

.alert-error .alert-icon {
  background-color: #ef4444;
  color: white;
}

.alert-warning .alert-icon {
  background-color: #f59e0b;
  color: white;
}

.alert-info .alert-icon {
  background-color: #3b82f6;
  color: white;
}

.alert-text {
  flex: 1 1;
  font-size: 1.3rem;
}

.alert-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.2s;
  padding: 0;
  line-height: 1;
  color: inherit;
}

.alert-close:hover {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profil/components/AlertMessage.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,UAAU;EACV,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/**\n * CSS pour le composant AlertMessage\n */\n\n.alert-message {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.alert-success {\n  background-color: #dcfce7;\n  border: 1px solid #86efac;\n  color: #166534;\n}\n\n.alert-error {\n  background-color: #fee2e2;\n  border: 1px solid #fca5a5;\n  color: #991b1b;\n}\n\n.alert-warning {\n  background-color: #fef3c7;\n  border: 1px solid #fcd34d;\n  color: #92400e;\n}\n\n.alert-info {\n  background-color: #dbeafe;\n  border: 1px solid #93c5fd;\n  color: #1e40af;\n}\n\n.alert-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  font-weight: bold;\n  font-size: 1.1rem;\n  flex-shrink: 0;\n}\n\n.alert-success .alert-icon {\n  background-color: #22c55e;\n  color: white;\n}\n\n.alert-error .alert-icon {\n  background-color: #ef4444;\n  color: white;\n}\n\n.alert-warning .alert-icon {\n  background-color: #f59e0b;\n  color: white;\n}\n\n.alert-info .alert-icon {\n  background-color: #3b82f6;\n  color: white;\n}\n\n.alert-text {\n  flex: 1;\n  font-size: 1.3rem;\n}\n\n.alert-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  opacity: 0.6;\n  transition: opacity 0.2s;\n  padding: 0;\n  line-height: 1;\n  color: inherit;\n}\n\n.alert-close:hover {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
